module.exports = __webpack_public_path__ + "static/media/icon-moderne-praxis.565cb9a1.svg";